<div class="itb-json-viewer">
    <ngx-json-viewer [json]="jsonObject" [expanded]="isExpanded"></ngx-json-viewer>
</div>
